/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DrugbankLabeller
 */
export interface DrugbankLabeller {
    /**
     * 
     * @type {string}
     * @memberof DrugbankLabeller
     */
    name?: string;
}

/**
 * Check if a given object implements the DrugbankLabeller interface.
 */
export function instanceOfDrugbankLabeller(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DrugbankLabellerFromJSON(json: any): DrugbankLabeller {
    return DrugbankLabellerFromJSONTyped(json, false);
}

export function DrugbankLabellerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DrugbankLabeller {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function DrugbankLabellerToJSON(value?: DrugbankLabeller | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

